import React, { Component } from 'react';
import Header from 'components/layout/Partials/Header';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty, map } from 'lodash';
import { withRouter } from 'react-router-dom';
import Loading from 'components/common/Loading';
import { getGroups } from 'redux/actions/groupsActions';
import * as Icon from 'react-feather';
import axios from 'axios';
import { ToastsStore } from 'react-toasts';
import { logoutUser } from 'redux/actions/authActions';
import SelectFieldGroup from 'components/common/SelectFieldGroup';
import { Theme } from 'utils/Theme';
import { withStyles } from '@material-ui/styles';
import AdminLayout from 'components/layout/AdminLayout';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import moment from 'moment';
import {
    Grid,
    Box,
    Button,
    Paper,
    Divider,
    Typography,
} from '@material-ui/core';
import clsx from 'clsx';
import UserProfileCard from './Partials/userProfileCard';

const styles = Theme();

class ViewUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            profile: null,
            group: '',
            errors: {},
            password: '',
            newPassword: '',
            confirmPassword: '',
            groupsOptions: [],
            showResourceDeleteConfirmWindow: false,
            filters: null,
            copied: false,

            toDelete: {
                type: '',
                id: '',
            },
        };
        this.getProfile = this.getProfile.bind(this);
        this.changePasswordRequest = this.changePasswordRequest.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onResourceSelect = this.onResourceSelect.bind(this);
        this.onResourceFormSubmit = this.onResourceFormSubmit.bind(this);
    }

    resourceDeleteConfirmWindow(type, id) {
        this.setState({
            showResourceDeleteConfirmWindow: true,
            toDelete: { type, id },
        });
    }

    resourceDeleteConfirmed() {
        const type = this.state.toDelete.type;
        const id = this.props.match.params.id;
        const group_id = this.state.toDelete.id;

        axios
            .delete(`/api/groups/resources/${type}/${group_id}/${id}`)
            .then((res) => {
                this.setState({
                    showResourceDeleteConfirmWindow: true,
                    toDelete: { type, id },
                });
                this.getProfile(this.props.match.params.id);
                ToastsStore.success(`${group_id} removed from group`);
            })
            .catch((err) => {
                this.setState({ errors: err.response.data });
            });
    }

    resourceDeleteCancelled() {
        this.setState({
            showResourceDeleteConfirmWindow: false,
            toDelete: { type: '', id: '' },
        });
    }

    onChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    onResourceSelect(e) {
        e.preventDefault();
        const group = e.target.value;
        this.setState({ group });
    }

    onResourceFormSubmit(e) {
        e.preventDefault();
        const resourceData = {
            type: 'users',
            resource_id: this.props.match.params.id,
        };

        const group_id = this.state.group;

        axios
            .post(`/api/groups/resources/${group_id}`, resourceData)
            .then(() => {
                this.getProfile();
                ToastsStore.success(
                    `${resourceData.type} ${resourceData.resource_id} added to group.`
                );
            })
            .catch((err) => {
                this.setState({ errors: err.response.data });
            });
    }

    getProfile() {
        axios
            .get(`/api/users/${this.props.match.params.id}`)
            .then((res) => {
                this.setState({ profile: res.data, loading: false });
            })
            .catch((err) => {
                this.setState({ errors: err });
            });
    }

    changePasswordRequest(e) {
        e.preventDefault();
        const passwordData = {
            userId: this.state.profile._id,
        };

        axios
            .post('/api/users/change-password-email', passwordData)
            .then((res) => {
                this.getProfile();
                ToastsStore.success('Password change successful');
            })
            .catch((err) => {
                this.setState({ errors: err.response.data });
            });
    }

    componentDidMount() {
        this.getProfile();
        this.props.getGroups();
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let groupOptions = [];
        const { groups } = nextProps;
        groupOptions = map(groups, (group) => {
            return { key: group._id, title: group.name };
        });

        return { groupOptions, groups };
    }

    render() {
        const { loading, profile } = this.state;
        const { classes } = this.props;

        return (
            <AdminLayout>
                <div className="o-page">
                    <Header hideSearchBar title={'User'} />
                    {profile === null || loading ? (
                        <Loading />
                    ) : (
                        <Box className={'u-m-xsmall'}>
                            <Grid container spacing={1}>
                                <Grid item md={6} sm={12}>
                                    <Paper className={clsx('u-p-small')}>
                                        <UserProfileCard
                                            classes={classes}
                                            profile={profile}
                                        />
                                        <Divider
                                            className={'u-mt-small u-mb-small'}
                                        />
                                        <Button
                                            onClick={() =>
                                                this.props.history.push(
                                                    `/settings/users/${profile._id}/delete`
                                                )
                                            }
                                            className={clsx(
                                                'u-mr-xsmall',
                                                classes.buttonPrimary
                                            )}
                                            disabled={
                                                profile._id ===
                                                this.props.auth.user.id
                                            }
                                        >
                                            Delete User
                                        </Button>
                                        {(!profile.changePasswordRequest ||
                                            !profile.changePasswordRequest
                                                .token ||
                                            moment(
                                                profile.changePasswordRequest
                                                    .date
                                            )
                                                .add(2, 'hours')
                                                .diff(moment().format()) <
                                                0) && (
                                            <Button
                                                className={clsx(
                                                    'u-mr-xsmall',
                                                    classes.whiteButton
                                                )}
                                                onClick={(e) =>
                                                    this.changePasswordRequest(
                                                        e
                                                    )
                                                }
                                            >
                                                Request Password Reset
                                            </Button>
                                        )}

                                        {profile.changePasswordRequest &&
                                            profile.changePasswordRequest
                                                .token &&
                                            moment(
                                                profile.changePasswordRequest
                                                    .date
                                            )
                                                .add(2, 'hours')
                                                .diff(moment().format()) >
                                                0 && (
                                                <CopyToClipboard
                                                    text={`${window.location.origin}/#/users/new-password/${profile.changePasswordRequest.token}`}
                                                    onCopy={() => {
                                                        ToastsStore.success(
                                                            'Url copied to clipboard'
                                                        );
                                                    }}
                                                >
                                                    <Button
                                                        className={clsx(
                                                            'u-mr-xsmall ',
                                                            classes.buttonPrimary
                                                        )}
                                                    >
                                                        <Icon.Copy size={10} />{' '}
                                                        Copy Password Reset URL
                                                    </Button>
                                                </CopyToClipboard>
                                            )}

                                        <Button
                                            onClick={() =>
                                                this.props.history.push(
                                                    `/settings/users/${profile._id}/edit`
                                                )
                                            }
                                            className={classes.whiteButton}
                                        >
                                            Edit User Account
                                        </Button>
                                    </Paper>
                                </Grid>
                                <Grid item md={6} sm={12}>
                                    <Paper className={clsx('u-p-small')}>
                                        <div
                                            className="u-p-small"
                                            style={{ minHeight: 410 }}
                                        >
                                            <h5
                                                className={` u-text-capitalize u-pb-xsmall`}
                                            >
                                                User Groups
                                            </h5>
                                            <Divider className=" u-mb-small" />

                                            <form
                                                onSubmit={
                                                    this.onResourceFormSubmit
                                                }
                                            >
                                                {!isEmpty(
                                                    this.state.groupOptions
                                                ) && (
                                                    <div className={'row'}>
                                                        <div
                                                            className={
                                                                'col-sm-10'
                                                            }
                                                        >
                                                            <SelectFieldGroup
                                                                options={
                                                                    this.state
                                                                        .groupOptions
                                                                }
                                                                label={
                                                                    'New User Groups'
                                                                }
                                                                type={'text'}
                                                                onChange={
                                                                    this
                                                                        .onResourceSelect
                                                                }
                                                                value={
                                                                    this.state
                                                                        .group
                                                                }
                                                                name={'group'}
                                                            />
                                                        </div>
                                                        <div
                                                            className={
                                                                'col-sm-2'
                                                            }
                                                        >
                                                            <div className="c-field u-mt-xsmall c-pt-cust-23">
                                                                <Button
                                                                    className={clsx(
                                                                        classes.buttonPrimary,
                                                                        'u-mr-xsmall'
                                                                    )}
                                                                    onClick={
                                                                        this
                                                                            .onResourceFormSubmit
                                                                    }
                                                                >
                                                                    ADD
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {isEmpty(
                                                    this.state.groupOptions
                                                ) && (
                                                    <>
                                                        <Typography
                                                            variant={'overline'}
                                                        >
                                                            Nothing to show
                                                        </Typography>
                                                        <Button
                                                            className={
                                                                classes.buttonPrimary
                                                            }
                                                            onClick={() =>
                                                                this.props.history.push(
                                                                    '/settings/groups/create'
                                                                )
                                                            }
                                                        >
                                                            Create Group
                                                        </Button>
                                                    </>
                                                )}
                                            </form>

                                            <ul className="u-m-zero list-group">
                                                {map(
                                                    profile.groups,
                                                    (group) => (
                                                        <li
                                                            key={group._id}
                                                            className="u-border-bottom u-border-top u-p-xsmall list-group-item d-flex justify-content-between align-items-center"
                                                        >
                                                            {group.name}
                                                            {!this.state
                                                                .showResourceDeleteConfirmWindow ||
                                                            this.state.toDelete
                                                                .id !==
                                                                group._id ? (
                                                                <span className="badge-pill o-line">
                                                                    <Button
                                                                        className={clsx(
                                                                            classes.buttonPrimary,
                                                                            'u-mr-xsmall'
                                                                        )}
                                                                        onClick={(
                                                                            e
                                                                        ) => {
                                                                            this.resourceDeleteConfirmWindow(
                                                                                'users',
                                                                                group._id
                                                                            );
                                                                        }}
                                                                    >
                                                                        Delete
                                                                    </Button>
                                                                    <Button
                                                                        onClick={() =>
                                                                            this.props.history.push(
                                                                                `/settings/groups/${group._id}/view`
                                                                            )
                                                                        }
                                                                        className={clsx(
                                                                            classes.whiteButton,
                                                                            'u-mr-xsmall'
                                                                        )}
                                                                    >
                                                                        Edit
                                                                    </Button>
                                                                </span>
                                                            ) : (
                                                                <span className="badge-pill o-line">
                                                                    <Button
                                                                        type={
                                                                            'button'
                                                                        }
                                                                        className={clsx(
                                                                            classes.buttonPrimary,
                                                                            'u-mr-xsmall'
                                                                        )}
                                                                        onClick={(
                                                                            e
                                                                        ) => {
                                                                            this.resourceDeleteConfirmed();
                                                                        }}
                                                                    >
                                                                        Delete
                                                                        User
                                                                        From
                                                                        Group
                                                                    </Button>
                                                                    <Button
                                                                        type={
                                                                            'button'
                                                                        }
                                                                        className={clsx(
                                                                            classes.whiteButton
                                                                        )}
                                                                        onClick={(
                                                                            e
                                                                        ) => {
                                                                            this.resourceDeleteCancelled();
                                                                        }}
                                                                    >
                                                                        Cancel
                                                                    </Button>
                                                                </span>
                                                            )}
                                                        </li>
                                                    )
                                                )}
                                            </ul>
                                        </div>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Box>
                    )}
                </div>
            </AdminLayout>
        );
    }
}

ViewUser.propTypes = {
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object,
    getGroups: PropTypes.func.isRequired,
    classes: PropTypes.object,
    history: PropTypes.object,
    groups: PropTypes.array,
    match: PropTypes.object,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    errors: state.errors,
    groups: state.groups?.groups,
});
export default connect(mapStateToProps, {
    logoutUser,
    getGroups,
})(withRouter(withStyles(styles)(ViewUser)));
